<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/99hGs6/tc-custom/9781488047459.jpg?1727496702803" alt="This image is the cover for the book Reclaimed by Her Rebel Knight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reclaimed by Her Rebel Knight
      </h1>
      <p class="bookDescription body article font2">
        <b>An woman marries a stranger to secure her inheritance, then falls for her husband when he returns from war in this medieval romance.</b><br/><br/>When Constance inherited her father’s lands, she had no choice but to marry cold-hearted Matthew Wintour. He left her for the battlefield, without even a wedding night. Five years later, Matthew has returned a valiant knight! But Constance is no longer a frightened girl. And, this time, she must reach out to discover the honorable man behind the armor and what pleasures await them in the marriage bed . . .<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenni Fletcher
      </h2>
      
      <p class="authorDescription body article">Jenni Fletcher is the author of more than 15 historical romances, ranging from the Roman to Victorian eras because she has historical commitment issues. She has a PhD in English, has been nominated for 4 RoNA Awards and won the Libert&agrave; Books Shorter Romantic Novel Award in 2020. She grew up in Scotland and Somerset and now lives in Yorkshire with her family. In her spare time, she enjoys mountain biking, baking and, of course, reading.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d5573b12